var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.437745 13.9979H3.17409C3.45118 13.9979 3.71164 13.8902 3.90731 13.6941L13.704 3.89735C13.8997 3.70168 14.0078 3.44122 14.0078 3.16413C14.0078 2.88703 13.8997 2.62658 13.704 2.4309L11.567 0.293836C11.1752 -0.0979453 10.4923 -0.0979453 10.1005 0.293836L0.304232 10.0901C0.110749 10.2827 0 10.5502 0 10.8238V13.5601C0 13.8018 0.19611 13.9979 0.437745 13.9979ZM3.17346 13.1223H0.874867V10.8237C0.874867 10.7808 0.891939 10.7401 0.922143 10.7095L9.09507 2.53694L11.4605 4.90232L3.28771 13.0751C3.25707 13.1057 3.2168 13.1223 3.17346 13.1223ZM12.0794 4.28335L9.71405 1.91798L10.7193 0.91277C10.8012 0.830474 10.8651 0.830474 10.9474 0.91277L13.0844 3.04984C13.1256 3.09099 13.1317 3.13914 13.1317 3.16409C13.1317 3.18904 13.1256 3.23719 13.0844 3.27834L12.0794 4.28335ZM2.71313 12.0722C2.79892 12.1864 2.93025 12.2468 3.06332 12.2468C3.15481 12.2468 3.24717 12.2184 3.32597 12.1593C3.51901 12.014 3.55797 11.7395 3.41264 11.5465C3.13905 11.1818 2.81512 10.8583 2.45048 10.5839C2.257 10.4394 1.98297 10.4779 1.83764 10.671C1.69231 10.864 1.73126 11.1385 1.92431 11.2838C2.22329 11.5084 2.48856 11.7736 2.71313 12.0722Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.437745 13.9979H3.17409C3.45118 13.9979 3.71164 13.8902 3.90731 13.6941L13.704 3.89735C13.8997 3.70168 14.0078 3.44122 14.0078 3.16413C14.0078 2.88703 13.8997 2.62658 13.704 2.4309L11.567 0.293836C11.1752 -0.0979453 10.4923 -0.0979453 10.1005 0.293836L0.304232 10.0901C0.110749 10.2827 0 10.5502 0 10.8238V13.5601C0 13.8018 0.19611 13.9979 0.437745 13.9979ZM3.17346 13.1223H0.874867V10.8237C0.874867 10.7808 0.891939 10.7401 0.922143 10.7095L9.09507 2.53694L11.4605 4.90232L3.28771 13.0751C3.25707 13.1057 3.2168 13.1223 3.17346 13.1223ZM12.0794 4.28335L9.71405 1.91798L10.7193 0.91277C10.8012 0.830474 10.8651 0.830474 10.9474 0.91277L13.0844 3.04984C13.1256 3.09099 13.1317 3.13914 13.1317 3.16409C13.1317 3.18904 13.1256 3.23719 13.0844 3.27834L12.0794 4.28335ZM2.71313 12.0722C2.79892 12.1864 2.93025 12.2468 3.06332 12.2468C3.15481 12.2468 3.24717 12.2184 3.32597 12.1593C3.51901 12.014 3.55797 11.7395 3.41264 11.5465C3.13905 11.1818 2.81512 10.8583 2.45048 10.5839C2.257 10.4394 1.98297 10.4779 1.83764 10.671C1.69231 10.864 1.73126 11.1385 1.92431 11.2838C2.22329 11.5084 2.48856 11.7736 2.71313 12.0722Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9028,
    height: 24.9028,
    fill: "#8A8E96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.9c6dcb5a52d1945def2d7b337ba7892c.svg";
export { ForwardRef as ReactComponent };